import React, { useRef } from 'react';
import { LayoutDashboardLeftMenuItem } from '../LayoutDashboardLeftMenuItem/LayoutDashboardLeftMenuItem';
import { useObservableEagerState, useObservableState } from 'observable-hooks';
import { getCustomerStore } from 'stores/customer.store';
import { PDropdown } from 'components/prime/PDropdown/PDropdown';
import { LayoutDashboardLeftMenuCustomersStyle as S } from './LayoutDashboardLeftMenuCustomers.style';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { useClassNames } from 'hooks/useClassNames';
import { useLeftMenuOpen } from 'hooks/useLeftMenuOpen';

export const LayoutDashboardLeftMenuCustomers: React.FC = () => {
  const ref = useRef<Dropdown>(null);
  const customers = useObservableState(getCustomerStore().$customers, []);
  const customer = useObservableEagerState(getCustomerStore().$customer);
  const { isLeftMenuOpen } = useLeftMenuOpen();
  const customerSelectionDisabled = customers.length <= 1;

  const handleCustomer = (e: DropdownChangeEvent) => {
    const slug = customers.find((c) => c.id === e.target.value)?.slug;
    if (slug) window.location.href = `${window.location.origin}/${slug}/get-started`;
  };

  const dropdownPanelClasses = useClassNames(
    {
      'is-open': isLeftMenuOpen,
    },
    'left-menu-customers-dropdown-panel'
  );

  return (
    <S.Container>
      <LayoutDashboardLeftMenuItem
        className="left-menu-closed-element left-menu-customers-button"
        item={{ icon: 'chevronSelectorVerticalLine', tooltip: customer?.name }}
        onClick={() => !customerSelectionDisabled && ref?.current?.show()}
      />
      <PDropdown
        ref={ref}
        containerClassName="left-menu-customers-dropdown layout-dashboard-left-menu-option-customers"
        value={customer?.id}
        options={customers}
        optionValue="id"
        optionLabel="name"
        disabled={customerSelectionDisabled}
        filter
        filterBy="name"
        onChange={handleCustomer}
        panelClassName={dropdownPanelClasses}
        data-testid="input-top-bar-company"
      />
      <S.Global />
    </S.Container>
  );
};
